import { render, staticRenderFns } from "./MySections.vue?vue&type=template&id=b13b5fde"
import script from "./MySections.vue?vue&type=script&lang=js"
export * from "./MySections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports